import React, { useState, useRef } from 'react';
import arrow from '/fallbacks/Arrow.svg';

const FooterColumn = ({ heading, links, index, data }) => {
	const [expanded, setExpanded] = useState(false);
	const listRef = useRef(null);
	const linksStyle = {
		'--footer-link-color': data.footer_link_text_color,
		'--footer-link-color-hover': data.footer_link_text_color_hover,
	};
	return (
		<div className={`footer__listContainer footer__listContainer--${index + 1}`}>
			<h3
				className="footer__heading"
				style={{ color: data?.footer_heading_text_color }}
				onClick={() => {
					setExpanded(!expanded);
				}}
			>
				{heading}
			</h3>
			<img
				src={arrow}
				alt="collapse list chevron"
				className="footer__chevron"
				style={{ transform: expanded && 'rotate(0deg' }}
			/>
			{links && (
				<div
					className="footer__column--wrapper"
					style={{
						height: expanded ? `${listRef.current?.clientHeight + 16}px` : '0px',
						overflow: expanded ? 'visible' : 'hidden',
						transition: 'height 300ms ease-in-out',
					}}
				>
					<ul
						className={expanded ? 'footer__list footer__list--expanded' : 'footer__list'}
						ref={listRef}
						style={{ height: 'auto' }}
					>
						{links.map((link, linkIndex) => {
							return (
								<li key={linkIndex} className="footer__listItem legal-link" id={`test-link-${linkIndex}`}>
									<a
										style={linksStyle}
										href={
											!link.footer_link_type
												? link.footer_custom_link && link.footer_custom_link.footer_custom_link_href
												: link.footer_post_link && link.footer_post_link.footer_post_link_href
										}
									>
										{!link.footer_link_type
											? link.footer_custom_link && link.footer_custom_link.tr_footer_custom_link_label
											: link.footer_post_link && link.footer_post_link.tr_footer_post_link_label}
									</a>
								</li>
							);
						})}
					</ul>
				</div>
			)}
		</div>
	);
};

export default FooterColumn;
